import { Navigate } from "react-router-dom";
import { useCopilotEnabled } from "@/hooks/useCopilotEnabled";

// Must stay at module level, for the same reason as RequireAuth in App.js.
//
// roles={[2]} is not a product gate: Gitcha has agents too, so a role check
// alone would put Copilot on gitcha.com. This adds the second condition - a
// non-default tenant with the flag on.
//
// Pulled into its own file (rather than living inline in App.js) so it can
// be tested without pulling in App.js's entire route/import graph.
export function RequireCopilot({ children }) {
  const enabled = useCopilotEnabled();
  if (!enabled) {
    return <Navigate to="/" replace />;
  }
  return children;
}
